<div class="row">
  <div class="col-12 d-flex align-items-center justify-content-between mb-3">
    <h5 class="bergh-text-primary m-0"></h5>
    <button class="btn bergh-btn-secondary text-white" (click)="addNewCost()">
      Item toevoegen
    </button>
  </div>
  @if (this.data.length>0) {
  <form [formGroup]="addCostForm" class="w-100 mx-2">
    <table class="table table-striped card-body">
      <thead>
        <tr class="row">
          <th class="col-5" scope="col">Kost</th>
          <th class="col-2" scope="col">Aantal</th>
          <th class="col-2" scope="col">Stuksprijs</th>
          <th class="col-1" scope="col">Totaal</th>
          <th class="col-2" scope="col">Acties</th>
        </tr>
      </thead>
      <tbody formArrayName="data">
        @for (item of data.controls; track item; let i = $index) {
        <tr class="row" formGroupName="{{ i }}" (change)="updateStatus(i)">
          <td class="col-5">
            <input
              type="text"
              class="form-control"
              (change)="updateStatus(i)"
              (keyup)="updateStatus(i)"
              formControlName="cost"
              id="in-cost"
            />
          </td>
          <td class="col-2">
            <input
              type="number"
              class="form-control"
              (change)="updateStatus(i)"
              (keyup)="updateStatus(i)"
              formControlName="noOfUnits"
              id="in-specification"
              min="1"
            />
          </td>
          <td class="col-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">€</span>
              </div>
              <input
                type="number"
                (change)="updateStatus(i)"
                (keyup)="updateStatus(i)"
                class="form-control"
                min="0"
                formControlName="pricePerUnit"
                id="in-price"
              />
            </div>
          </td>
          <td class="col-1">
            €{{
              this.addCostForm.value.data[i].noOfUnits *
                this.addCostForm.value.data[i].pricePerUnit
            }}
          </td>
          <td class="col-2 btn-delete">
            @if (!this.addCostForm.value.data[i].saved) {
            <i-feather
              class="feather-icon-custom-class mr-1"
              name="alert-triangle"
            ></i-feather>
            } @if (this.addCostForm.value.data[i].saved) {
            <i-feather
              class="feather-icon-custom-class"
              name="check"
            ></i-feather>
            }
            <div class="info-window bergh-shadow-one">
              <p class="text-dark">
                Weet je zeker dat je dit material wil verwijderen?
              </p>
              <div class="btn-collection">
                <button
                  class="btn btn-sm btn-secondary"
                  #no
                  type="button"
                  (click)="cancelDelete(no)"
                >
                  Annuleer
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  #yes
                  (click)="removeCost(i); cancelDelete(yes)"
                  type="button"
                >
                  Ja
                </button>
              </div>
            </div>
            <button
              class="btn btn-secondary ml-2 remove-btn"
              #delete
              (click)="openDelete(delete)"
              id="btn-delete-{{ i }}"
            >
              Verwijderen
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </form>
  }
</div>
